{% block swag_cms_extensions_form_element_text %}
    <mt-text-field
        :modelValue="field.translated ? field.translated.placeholder : field.placeholder"
        :label="field.translated ? field.translated.label : field.label"
        :required="field.required"
        :disabled
    />
{% endblock %}
